import type React from 'react';
import type { SearchResultProps } from './types';
import FdocList from '../../FdocList/FdocList';

const resourcePreviewProps = {
  appearence: {
    showRootInFilename: true,
  },
};

export const SearchResultsExternalItems: React.FC<SearchResultProps> = (props) => {
  const { queryHash, emptyStateTitle, emptyStateReason, total, isLoading, resources } = props;

  return (
    <FdocList
      layoutId={`searchbar-overlay-external-${queryHash}`}
      multiSelectLayerId="searchbar-with-overlay"
      resources={resources}
      viewMode="Detailed"
      onInfiniteTrigger={undefined}
      emptyStateImage={<img src="/images/empty-search.png" alt="empty-search" />}
      canMultiSelect={false}
      canModifyContent={false}
      zoomLevel={1}
      // setZoomLevel={setZoomLevel}
      emptyStateTitle={emptyStateTitle}
      emptyStateReason={emptyStateReason}
      isLoading={isLoading}
      resourcesTotalCount={total}
      skipAnimation
      resourcePreviewProps={resourcePreviewProps}
      uiContext="search"
    />
  );
};
